import styled from 'styled-components'

export const Center = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: center;
    gap: 20px;
`
